module.exports = __webpack_public_path__ + "img/project3_medium@2x.a4d3f4da.jpg";